import React from "react";
import Header from "./Header"
import Footer from "./Footer"

class Template extends React.Component {
    render() {
        return (
            <>
                <Header title="NP_HARD_" link="/"/>
                {this.props.content}
                <Footer />  
            </>
        )
    }
}
export default Template